import { AppThunkAction } from '../reducers';

// services
import * as Services from '../../services/PersonIdentifierTypes.Services';

// actions
import * as Actions from '../actions';
import * as ActionEvents from '../actions/PersonIdentifierTypes.Actions';

// models
import { ErrorType } from '../../models/HttpError';
import { IdentifierTypeViewModel, IdentifierTypeCreateCommand, IdentifierTypeUpdateCommand } from '../../models/Entities/Person/IdentifierType/IdentifierTypeModels';

export type KnownAction =
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeGetAllRequestAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeGetAllSuccessAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeGetAllFailureAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeGetByIdRequestAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeGetByIdSuccessAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeGetByIdFailureAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeCreateRequestAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeCreateSuccessAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeCreateFailureAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeUpdateRequestAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeUpdateSuccessAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeUpdateFailureAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeDeleteRequestAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeDeleteSuccessAction
    | Actions.PersonIdentifierTypes.PersonIdentifierTypeDeleteFailureAction;

const NotAuthorizedError: ErrorType = {
    ErrorCode: 401,
    ErrorMessage: 'Not authorized',
    Errors: []
};

export const actionCreators = {
    GetIdentifierTypes: (): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_GETALL_FAILURE, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_GETALL_REQUEST });

        Services.GetIdentifierTypes(token)
            .then((response: IdentifierTypeViewModel[]) => {
                dispatch({
                    type: ActionEvents.PERSON_IDENTIFIER_TYPE_GETALL_SUCCESS,
                    payload: response
                });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_GETALL_FAILURE, error });
            });
    },

    GetIdentifierTypeById: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_GETBYID_FAILURE, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_GETBYID_REQUEST, id });

        Services.GetIdentifierTypeById(token, id)
            .then((response: IdentifierTypeViewModel) => {
                dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_GETBYID_SUCCESS, payload: response });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_GETBYID_FAILURE, error });
            });
    },

    CreateIdentifierType: (payload: IdentifierTypeCreateCommand): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_CREATE_FAILURE, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_CREATE_REQUEST, payload });

        Services.CreateIdentifierType(token, payload)
            .then((created: IdentifierTypeViewModel) => {
                dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_CREATE_SUCCESS, payload: created });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_CREATE_FAILURE, error });
            });
    },

    UpdateIdentifierType: (payload: IdentifierTypeUpdateCommand): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_UPDATE_FAILURE, id: payload.id, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_UPDATE_REQUEST, payload });

        Services.UpdateIdentifierType(token, payload)
            .then((updated: IdentifierTypeViewModel) => {
                dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_UPDATE_SUCCESS, payload: updated });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_UPDATE_FAILURE, id: payload.id, error });
            });
    },

    DeleteIdentifierType: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

        if (!token) {
            dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_DELETE_FAILURE, id, error: NotAuthorizedError });
            return;
        }

        dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_DELETE_REQUEST, id });

        Services.DeleteIdentifierType(token, id)
            .then(() => {
                dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_DELETE_SUCCESS, id });
            })
            .catch((error: ErrorType) => {
                dispatch({ type: ActionEvents.PERSON_IDENTIFIER_TYPE_DELETE_FAILURE, id, error });
            });
    }
};
